/**
 * @flow
 * @relayHash 1e5b5377a608b252aa4c404e56902154
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type getCustomerQueryVariables = {|
  id: string
|};
export type getCustomerQueryResponse = {|
  +getCustomer: {|
    +id: string,
    +name: string,
    +createdAt: any,
    +updatedAt: any,
  |}
|};
export type getCustomerQuery = {|
  variables: getCustomerQueryVariables,
  response: getCustomerQueryResponse,
|};
*/


/*
query getCustomerQuery(
  $id: String!
) {
  getCustomer(id: $id) {
    id
    name
    createdAt
    updatedAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "getCustomer",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "CustomerModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "createdAt",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "updatedAt",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "getCustomerQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "getCustomerQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "getCustomerQuery",
    "id": null,
    "text": "query getCustomerQuery(\n  $id: String!\n) {\n  getCustomer(id: $id) {\n    id\n    name\n    createdAt\n    updatedAt\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f3028512e46f1bb5aa5288799d13ff31';
module.exports = node;
